import React, { useState } from 'react';
import { LegalModal } from './LegalModal';
export function Footer() {
  const [showPrivacy, setShowPrivacy] = useState(false);
  const [showTerms, setShowTerms] = useState(false);
  return <>
      <footer className="w-full bg-navy-dark border-t border-gold/20 py-8 px-4" data-id="element-7">
        <div className="max-w-6xl mx-auto" data-id="element-8">
          <div className="flex flex-col md:flex-row items-center justify-center gap-6 text-center" data-id="element-9">
            <p className="font-body text-gray-400 text-sm" data-id="element-10">
              © 2026 Proyecto Patriarca. Todos los derechos reservados.
            </p>
            <div className="flex items-center gap-6" data-id="element-11">
              <button onClick={() => setShowPrivacy(true)} className="font-body text-gray-400 hover:text-gold transition-colors text-sm underline" data-id="element-12">
                Política de Privacidad
              </button>
              <span className="text-gray-600" data-id="element-13">•</span>
              <button onClick={() => setShowTerms(true)} className="font-body text-gray-400 hover:text-gold transition-colors text-sm underline" data-id="element-14">
                Términos de Servicio
              </button>
            </div>
          </div>
        </div>
      </footer>

      {/* Privacy Policy Modal */}
      <LegalModal isOpen={showPrivacy} onClose={() => setShowPrivacy(false)} title="Política de Privacidad" data-id="element-15">
        <div className="space-y-6 text-gray-300" data-id="element-16">
          <p className="text-sm text-gray-400" data-id="element-17">
            Última actualización: Febrero 2026
          </p>

          <section data-id="element-18">
            <h3 className="font-heading text-xl text-white mb-3" data-id="element-19">
              1. Información que Recopilamos
            </h3>
            <p data-id="element-20">
              En Proyecto Patriarca, recopilamos información que nos
              proporcionas directamente al realizar una compra, incluyendo tu
              nombre, dirección de correo electrónico, y información de pago
              necesaria para procesar tu transacción.
            </p>
          </section>

          <section data-id="element-21">
            <h3 className="font-heading text-xl text-white mb-3" data-id="element-22">
              2. Uso de la Información
            </h3>
            <p data-id="element-23">Utilizamos tu información para:</p>
            <ul className="list-disc pl-6 space-y-2 mt-2" data-id="element-24">
              <li data-id="element-25">Procesar y completar tu compra del manual digital</li>
              <li data-id="element-26">Enviarte el acceso al contenido adquirido</li>
              <li data-id="element-27">Comunicarnos contigo sobre tu compra</li>
              <li data-id="element-28">Mejorar nuestros productos y servicios</li>
            </ul>
          </section>

          <section data-id="element-29">
            <h3 className="font-heading text-xl text-white mb-3" data-id="element-30">
              3. Protección de Datos
            </h3>
            <p data-id="element-31">
              Implementamos medidas de seguridad apropiadas para proteger tu
              información personal contra acceso no autorizado, alteración,
              divulgación o destrucción. Toda la información de pago se procesa
              a través de procesadores de pago seguros y certificados.
            </p>
          </section>

          <section data-id="element-32">
            <h3 className="font-heading text-xl text-white mb-3" data-id="element-33">
              4. Compartir Información
            </h3>
            <p data-id="element-34">
              No vendemos, intercambiamos ni transferimos tu información
              personal a terceros, excepto cuando sea necesario para procesar tu
              compra (procesadores de pago) o cuando la ley lo requiera.
            </p>
          </section>

          <section data-id="element-35">
            <h3 className="font-heading text-xl text-white mb-3" data-id="element-36">5. Cookies</h3>
            <p data-id="element-37">
              Utilizamos cookies para mejorar tu experiencia en nuestro sitio
              web. Puedes configurar tu navegador para rechazar cookies, aunque
              esto puede afectar algunas funcionalidades del sitio.
            </p>
          </section>

          <section data-id="element-38">
            <h3 className="font-heading text-xl text-white mb-3" data-id="element-39">
              6. Tus Derechos
            </h3>
            <p data-id="element-40">
              Tienes derecho a acceder, corregir o eliminar tu información
              personal. Para ejercer estos derechos, contáctanos a través de los
              canales proporcionados en el momento de la compra.
            </p>
          </section>

          <section data-id="element-41">
            <h3 className="font-heading text-xl text-white mb-3" data-id="element-42">
              7. Cambios a esta Política
            </h3>
            <p data-id="element-43">
              Nos reservamos el derecho de actualizar esta política de
              privacidad en cualquier momento. Te notificaremos sobre cambios
              significativos publicando la nueva política en esta página.
            </p>
          </section>
        </div>
      </LegalModal>

      {/* Terms of Service Modal */}
      <LegalModal isOpen={showTerms} onClose={() => setShowTerms(false)} title="Términos de Servicio" data-id="element-44">
        <div className="space-y-6 text-gray-300" data-id="element-45">
          <p className="text-sm text-gray-400" data-id="element-46">
            Última actualización: Febrero 2026
          </p>

          <section data-id="element-47">
            <h3 className="font-heading text-xl text-white mb-3" data-id="element-48">
              1. Aceptación de Términos
            </h3>
            <p data-id="element-49">
              Al comprar y acceder a Proyecto Patriarca, aceptas estar sujeto a
              estos Términos de Servicio. Si no estás de acuerdo con alguna
              parte de estos términos, no debes realizar la compra.
            </p>
          </section>

          <section data-id="element-50">
            <h3 className="font-heading text-xl text-white mb-3" data-id="element-51">
              2. Descripción del Producto
            </h3>
            <p data-id="element-52">
              Proyecto Patriarca es un manual digital táctico diseñado para
              padres primerizos hispanos en Estados Unidos. El producto incluye:
            </p>
            <ul className="list-disc pl-6 space-y-2 mt-2" data-id="element-53">
              <li data-id="element-54">Manual completo en formato digital (PDF)</li>
              <li data-id="element-55">Acceso inmediato después del pago</li>
              <li data-id="element-56">Estrategias y guías prácticas</li>
            </ul>
          </section>

          <section data-id="element-57">
            <h3 className="font-heading text-xl text-white mb-3" data-id="element-58">
              3. Compra y Pago
            </h3>
            <p data-id="element-59">
              El precio del manual es de $6.39 USD (precio con descuento del 76%
              sobre el precio original de $27). El pago se procesa de forma
              segura a través de nuestros procesadores de pago autorizados. Una
              vez completado el pago, recibirás acceso inmediato al contenido
              digital.
            </p>
          </section>

          <section data-id="element-60">
            <h3 className="font-heading text-xl text-white mb-3" data-id="element-61">
              4. Propiedad Intelectual
            </h3>
            <p data-id="element-62">
              Todo el contenido de Proyecto Patriarca, incluyendo textos,
              gráficos, logos y material educativo, está protegido por derechos
              de autor. Al comprar el manual, obtienes una licencia personal, no
              transferible, para uso individual. No está permitido:
            </p>
            <ul className="list-disc pl-6 space-y-2 mt-2" data-id="element-63">
              <li data-id="element-64">Reproducir o distribuir el contenido sin autorización</li>
              <li data-id="element-65">Modificar o crear trabajos derivados</li>
              <li data-id="element-66">Usar el contenido con fines comerciales</li>
              <li data-id="element-67">Compartir tu acceso con terceros</li>
            </ul>
          </section>

          <section data-id="element-68">
            <h3 className="font-heading text-xl text-white mb-3" data-id="element-69">
              5. Política de Reembolso
            </h3>
            <p data-id="element-70">
              Debido a la naturaleza digital del producto y el acceso inmediato
              proporcionado, todas las ventas son finales. No ofrecemos
              reembolsos una vez que has accedido al contenido del manual.
            </p>
          </section>

          <section data-id="element-71">
            <h3 className="font-heading text-xl text-white mb-3" data-id="element-72">
              6. Descargo de Responsabilidad
            </h3>
            <p data-id="element-73">
              El contenido de Proyecto Patriarca es informativo y educativo. No
              constituye asesoramiento legal, financiero, médico o profesional.
              Siempre consulta con profesionales calificados para decisiones
              importantes relacionadas con tu familia y finanzas.
            </p>
          </section>

          <section data-id="element-74">
            <h3 className="font-heading text-xl text-white mb-3" data-id="element-75">
              7. Limitación de Responsabilidad
            </h3>
            <p data-id="element-76">
              En la máxima medida permitida por la ley, Proyecto Patriarca no
              será responsable por daños indirectos, incidentales, especiales o
              consecuentes que resulten del uso o la imposibilidad de usar el
              manual.
            </p>
          </section>

          <section data-id="element-77">
            <h3 className="font-heading text-xl text-white mb-3" data-id="element-78">
              8. Modificaciones
            </h3>
            <p data-id="element-79">
              Nos reservamos el derecho de modificar estos términos en cualquier
              momento. Los cambios entrarán en vigor inmediatamente después de
              su publicación en esta página.
            </p>
          </section>

          <section data-id="element-80">
            <h3 className="font-heading text-xl text-white mb-3" data-id="element-81">
              9. Ley Aplicable
            </h3>
            <p data-id="element-82">
              Estos términos se rigen por las leyes de Estados Unidos. Cualquier
              disputa relacionada con estos términos estará sujeta a la
              jurisdicción exclusiva de los tribunales competentes.
            </p>
          </section>
        </div>
      </LegalModal>
    </>;
}